import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FetchNotificationSubscriptionsTypesService(token,data) {
    console.log(data)
    return axios.post(`${CURRENT_API_URL}/amazonNotifications/notificationSubscriptionsTypes`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("Notifications Subscriptions fetched successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching Notifications Subscriptions, Please try again later.");
        return false;
    });
}

export default FetchNotificationSubscriptionsTypesService;
